import React from 'react';

const ReportLegend = ({ title, legends = false }) => (
  <div className="breadcrumb-extra-row legend-row">
    <div className="breadcrumb-extra-left">
      {title}
    </div>
    {legends === true && (
    <div className="breadcrumb-extra-right legend-right">
      <span className="legend-title">Legend:</span>

      <div className="legend-item">
        <span className="rect-icon-blue" />
        <span>Match Source</span>
      </div>

      <div className="legend-item">
        <span className="rect-icon-red" />
        <span>Exact Duplicate</span>
      </div>

      <div className="legend-item">
        <span className="rect-icon-yellow" />
        <span>Partial Duplicate</span>
      </div>
    </div>
    )}

  </div>
);

export default ReportLegend;
